import React from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  FaHome, 
  FaShoppingBag, 
  FaShoppingCart, 
  FaInfoCircle, 
  FaPhoneAlt,
  FaFire,
  FaEnvelope
} from "react-icons/fa";

function MobileNavigation({ storeClose = 0, cartCount = 0 }) {
  const location = useLocation();
  
  // Check active path
  const isActive = (path) => {
    return location.pathname === path || 
           (path === "/" && location.pathname === "/home");
  };

  return (
    <nav className="mathi-mobile-nav">
      <div className="minifooter1">
            <div className="minimenu">
                
            <Link to="/home">
                  <div style={{display:"flex", flexDirection:"column",color:"white"}}>
                <i class="bi bi-house-door" style={{marginLeft:"12px",fontSize:"1.4rem"}}></i>
                   Home
                   </div>
                   </Link>
      
      
                   <Link to="/about">
                <div style={{display:"flex", flexDirection:"column",color:"white"}}>
                <i class="bi bi-journal-text officon" style={{marginLeft:"20px",fontSize:"1.4rem",color:"white"}}></i>
                   About Us
                   </div>
                   </Link>
               
                
                <Link to="/quick">
                <div style={{display:"flex", flexDirection:"column",color:"white"}}>
                <i class="bi bi-bag" style={{marginLeft:"15px",fontSize:"1.4rem"}}></i>
                   Enquiry
                   </div>
                   </Link>
                
                   
                   
                <Link to="/contact">
                <div style={{display:"flex", flexDirection:"column",color:"white"}}>
                <i class="bi bi-telephone" style={{marginLeft:"12px",fontSize:"1.4rem"}}></i>
                   Contact
                   </div>
                   </Link>
                
              </div>
            </div>
    </nav>
  );
}

export default MobileNavigation;